import React from "react";
import { IMultiSelectProps, ISelectProps, MultiSelectInput } from "~/components/Controls/Select";
import { useResource } from "~/lib/loader";
import { ID } from "~/lib/model";
import { fetchDataCubesAgency } from "../api";
import { sortByString } from "~/lib/sort";
import { TableSortDirection } from "~/components/Table";
import { FormField, hasError, IFieldProps, onChangeField } from "~/components/Form";
import { Intent } from "~/lib/intent";

type ISelectDataCubeAgencyProps = Omit<ISelectProps<ID>, "items">;

type IMultiSelectDataCubesAgencyProps = Omit<IMultiSelectProps<ID>, "items">;

export const MultiSelectDataCubesAgency = ({ disabled, ...props }: IMultiSelectDataCubesAgencyProps) => {
  const { resource, isPending } = useResource(() => fetchDataCubesAgency(), []);
  return (
    <MultiSelectInput
      {...props}
      disabled={disabled || isPending}
      rightIcon={isPending && <i className="fa fa-spinner fa-spin" />}
      items={sortByString(
        resource.map((cube) => ({
          label: cube.name,
          value: cube.id,
        })),
        "label",
        TableSortDirection.ASC
      )}
    />
  );
};

export const MultiSelectDataCubesAgencyField = (props: IFieldProps<ISelectDataCubeAgencyProps>) => (
  <FormField {...props}>
    <MultiSelectDataCubesAgency
      {...props.options}
      intent={hasError(props) && Intent.DANGER}
      value={props.field.value}
      onChange={(value) => onChangeField(props, value)}
    />
  </FormField>
);
